import React from 'react';
import API from "../../Services/API";
import {toast} from "react-toastify";
import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";
import { useParams} from "react-router-dom";
import Header from "../../Layouts/Header";
import Navbar from "../../Layouts/Navbar";
import {AiOutlineAppstoreAdd} from "react-icons/ai";
import {HiOutlineQrcode, HiTruck} from "react-icons/hi";
import {TbBuildingStore, TbStatusChange} from "react-icons/tb";
import {BsCalendar4Week} from "react-icons/bs";


function OrderDetails() {

    const {id} = useParams();
    const [isLoaded, setIsLoaded] = React.useState(false);
    const [documentFile, setDocumentFile] = React.useState(null);
    const [order, setOrder] = React.useState([]);
    const [devices, setDevices] = React.useState([]);
    const [users, setUsers] = React.useState([]);
    const [user, setUser] = React.useState(0);
    const [checkList, setCheckList] = React.useState([]);
    const [device, setDevice] = React.useState(0);
    const [empty, setEmpty] = React.useState(0);
    const [full, setFull] = React.useState(0);
    const [checks, setChecks] = React.useState(0);


    React.useEffect(() => {

        const params = {
            'processFor' : 'Sales',
            'group_id' : 7
        }

        API.getOrder(params , id)
            .then((response) => {
                setOrder(response.data);

                API.getDevices(params)
                    .then((response) => {
                        setDevices(response.data[0]);
                        setIsLoaded(true);

                    })

                API.getCheckList(params)
                    .then((response) => {
                        setCheckList(response.data);
                        setIsLoaded(true);

                    })
                API.getUsers(params)
                    .then((response) => {
                        setUsers(response.data);

                    })
            })
            .catch((error) => {

                if(error.response) {
                    toast.error(error.response.data.message);
                    setTimeout (() => {
                          window.history.back()
                    },400)
                }
                else {
                    toast.error(error.message);
                    setTimeout (() => {
                        window.history.back()
                    },400)
                }
            });


    }, [id]);


    const onDocChange = (event) => {
        setDocumentFile(event.target.files[0])
    }

    const onRemoveFileClick = (id) => {
        API.removeFile(id)
            .then((response) => {
                toast.success(response.message);
                window.location.reload()
            })
            .catch((error) => {
                toast.error(error.response.data.message)
            });
    }
    const onUploadClick = () => {
        const formData = new FormData();
        const file = documentFile;

        if (file) {
            if(file.size > 2485760) {
                toast.error('حجم فایل ارسالی نمی تواند بیشتر از 2 مگابایت باشد');
                return false;
            }
            formData.append('document_file', file);

        } else {
            toast.error('لطفا ابتدا یک فایل معتبر انتخاب کنید!');
            return false;
        }

        formData.append('document_title',  'تصویر بار - آپلود شده توسط نگهبانی ');

        formData.append('id', id);

        API.uploadFile(formData)
            .then((response) => {
                toast.success(response.message);
                window.location.reload()
            })
            .catch((error) => {
                toast.error(error.response.data.message)
            });
    }


    const onStatusButtonClick =  (statusId) => {
        if(checkList.length > checks) {
            toast.error('لطفا همه موارد چک لیست را کنترل کرده و تیک بزنید')
            return false ;
        }

        if(user < 1) {
            toast.error('نام خود را از لیست کاربران انتخاب کنید')
            return false ;
        }

        setIsLoaded(false);
        const request = {
            order_id: id,
            status_id : statusId,
            'processFor' : 'Guardian',
            device,
            empty,
            full,
            theUser: user
        }
        API.updateStatus( request )
            .then((response) => {
                toast.success(response.message);
                window.location.reload()
            })
            .catch((error) => {
                toast.error(error.response.data.message)
                setIsLoaded(true);
            });
    }


    return (
        <React.Fragment>
            <Header/>

            <Navbar page="home"/>
            <Toast/>
            {
                !isLoaded && <Loading/>
            }
            <main id="main" className="main rtl">

                <div className="pagetitle mb-5 border-bottom pb-4">
                    <h1>
                        <AiOutlineAppstoreAdd className='ms-2'/>
                        مدیریت سفارش
                    </h1>

                </div>

                <section className="section">
                    <div className="row">
                        <div className="col-lg-12">

                            <div className="card">
                                <div className="card-body">
                                    <div className="row mx-2 mb-3 border-bottom pb-2 pt-5">
                                        <div className="col-1">
                                            <TbBuildingStore />
                                        </div>
                                        <div className="col-5 text-small-2">
                                            نماینده:
                                        </div>
                                        <div className="col-6 text-start fw-bold text-small-2">
                                            {order?.vendor?.title}
                                            &nbsp;
                                            (
                                            {order?.vendor?.city}
                                            )
                                        </div>
                                    </div>
                                    <div className="row mx-2 mb-3 border-bottom pb-2 ">
                                        <div className="col-1">
                                            <HiOutlineQrcode />
                                        </div>
                                        <div className="col-5 text-small-2">
                                            کد سفارش:
                                        </div>
                                        <div className="col-6 text-start fw-bold text-small-2">
                                            {order.tracking_code}
                                        </div>
                                    </div>
                                    <div className="row mx-2 mb-3 border-bottom pb-2 ">
                                        <div className="col-1">
                                            <HiOutlineQrcode />
                                        </div>
                                        <div className="col-5 text-small-2">
                                             تعداد باتری:
                                        </div>
                                        <div className="col-6 text-start fw-bold ">
                                            {order.battery_qty}
                                        </div>
                                    </div>
                                    <div className="row mx-2 mb-3 border-bottom pb-2 ">
                                        <div className="col-1">
                                            <HiTruck />
                                        </div>
                                        <div className="col-5 text-small-2">
                                            مشخصات راننده:
                                        </div>
                                        <div className="col-6 text-start fw-bold text-small-2 ">
                                            {order.driver_info?.replace('X' , '')?.replace('X' , '')}
                                        </div>
                                    </div>
                                    <div className="row mx-2 mb-3 border-bottom pb-2">
                                        <div className="col-1">
                                            <TbStatusChange />
                                        </div>
                                        <div className="col-5 text-small-2">
                                            وضعیت سفارش
                                        </div>
                                        <div className="col-6 text-start fw-bold text-small-2" style={{color: order?.last_status?.color}}>
                                            {order?.last_status?.title}
                                        </div>


                                    </div>
                                    <div className="row mx-2 mb-3 pb-2 border-bottom">
                                        <div className="col-1">
                                            <BsCalendar4Week />
                                        </div>
                                        <div className="col-4 text-small-2">
                                            تاریخ ثبت
                                        </div>
                                        <div className="col-7 text-start fw-bold text-small-2">
                                            {order.date}
                                        </div>
                                    </div>

                                    <div className="row mx-2 mt-2">
                                        <div className="col-12 mt-4">
                                            <div className="card ">
                                                <div className="card-header text-end text-small-2">
                                                    تصاویر بار
                                                </div>
                                                <div className="card-body text-small-2">
                                                    <div className="row">
                                                        <div className="col-md-6 ">
                                                            <label className="custom-file-upload">
                                                                انتخاب تصویر
                                                                <input type="file" onChange={onDocChange}
                                                                       accept="image/*"
                                                                />
                                                            </label>

                                                            <div
                                                                className=" text-success text-small-2  bg-light mt-2 p-1 text-center">
                                                                &nbsp;
                                                                {
                                                                    documentFile ?
                                                                        " فایل انتخاب شده : " +
                                                                        documentFile.name
                                                                        : ''
                                                                }
                                                            </div>
                                                        </div>

                                                        <div className="col-md-6 text-left mt-3">
                                                            <button className="btn btn-secondary  w-100"
                                                                    onClick={onUploadClick}>


                                                                آپلود فایل

                                                            </button>
                                                        </div>

                                                    </div>
                                                </div>
                                                <div className="card-footer text-body-secondary">
                                                    {
                                                        order?.documents?.length > 0 &&
                                                        <ul className='text-small-3 text-muted opacity-75'>
                                                            <li>
                                                                لیست فایلها
                                                            </li>
                                                        </ul>
                                                    }


                                                    {
                                                        order?.documents?.map((doc, index) => {
                                                            return (
                                                                <span
                                                                    className="btn btn-dark mx-2 position-relative text-small-2 mb-5 "
                                                                    key={index}


                                                                >
                                                                <span role='button' onClick={() => {
                                                                    window.open(doc.path)
                                                                }}>{doc.title}</span>

                                                                    <span
                                                                        className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger "
                                                                        role='button'

                                                                        onClick={() => onRemoveFileClick(doc.id)}>
      حذف فایل

  </span>
                                                                </span>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            {
                                                order?.last_status?.id === 7 &&
                                                <div className="row">
                                                    <div className='col-md-3 mt-2 mb-3'>
                                                        <div className="form-floating ">
                                                            <input type="number"
                                                                   className="form-control text-center text-small-1 py-2"
                                                                   id="floatingInput"
                                                                   placeholder="n"

                                                                   value={empty}
                                                                   onChange={
                                                                       (ev) => {
                                                                           setEmpty(ev.target.value)
                                                                       }
                                                                   }
                                                            />
                                                            <label htmlFor="floatingInput"
                                                                   className="right-0 text-secondary text-small-1">
                                                                خالی بار
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <div className='col-md-3 mt-2 mb-3'>
                                                        <div className="form-floating ">
                                                            <input type="number"
                                                                   className="form-control text-center text-small-1 py-2"
                                                                   id="floatingInput"
                                                                   placeholder="n"

                                                                   value={full}
                                                                   onChange={
                                                                       (ev) => {
                                                                           setFull(ev.target.value)
                                                                       }
                                                                   }
                                                            />
                                                            <label htmlFor="floatingInput"
                                                                   className="right-0 text-secondary text-small-1">
                                                                پر بار
                                                            </label>
                                                        </div>
                                                    </div>

                                                    <div className="col-md-3  mt-3  ">
                                                        <select className="form-select w-100 bg-secondary-subtle"
                                                                aria-label="Default select"
                                                                onChange={(val) => {
                                                                    setDevice(val.target.value)
                                                                }}
                                                        >
                                                            <option value="0">
                                                                انتخاب دستگاه ردیاب
                                                            </option>
                                                            {
                                                                devices?.map(d => {
                                                                    return (
                                                                        <option value={d.code} key={d.id}>
                                                                            {
                                                                                d.code
                                                                            }
                                                                            -
                                                                            {
                                                                                d.title
                                                                            }
                                                                        </option>
                                                                    )
                                                                })
                                                            }
                                                        </select>
                                                    </div>

                                                    <div className="col-md-3  mt-3  ">
                                                        <select className="form-select w-100 bg-info-subtle"
                                                                aria-label="Default select"
                                                                onChange={(val) => {
                                                                    setUser(val.target.value)
                                                                }}
                                                        >
                                                            <option value="0">
                                                              انتخاب کاربر
                                                            </option>
                                                            {
                                                                users?.map(d => {
                                                                    return (
                                                                        <option value={d.id} key={d.id}>
                                                                            {
                                                                                d.name
                                                                            }
                                                                            -
                                                                            {
                                                                                d.surname
                                                                            }
                                                                        </option>
                                                                    )
                                                                })
                                                            }
                                                        </select>
                                                    </div>

                                                    <div className="col-md-12  mt-3  ">
                                                        <div className="row">
                                                            {
                                                                checkList?.map(cl => {
                                                                    return (
                                                                        <div
                                                                            className="col-md-4 mt-4 alert alert-light mx-2 py-2 px-4">
                                                                            <div
                                                                                className="form-check form-switch text-primary">
                                                                                <input className="form-check-input"
                                                                                       type="checkbox" role="switch"
                                                                                       id={'cbx' + cl.id}
                                                                                       onChange={(val) => {
                                                                                           if (val.target.checked) {
                                                                                               setChecks(checks + 1)
                                                                                           } else {
                                                                                               setChecks(checks - 1)
                                                                                           }
                                                                                       }}

                                                                                />
                                                                                <label className="form-check-label "
                                                                                       htmlFor={'cbx' + cl.id}
                                                                                       role="button">
                                                                                    {cl.title}
                                                                                    <div
                                                                                        className='mt-2 text-small-1 opacity-75'>
                                                                                        {cl.description}
                                                                                    </div>
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                    )
                                                                })
                                                            }
                                                        </div>
                                                    </div>


                                                    <div className="col-md-12  mt-3  ">
                                                        <button
                                                            className="btn btn-success text-center text-semi-big w-100 p-2 pr-4 "
                                                            onClick={
                                                                () => {
                                                                    onStatusButtonClick(14)
                                                                }
                                                            }
                                                            disabled={!isLoaded}
                                                        >
                                                            تایید خروج
                                                        </button>
                                                    </div>
                                                </div>
                                            }

                                        </div>
                                        <div className="col-12 mt-5">
                                            <div className=" ">
                                                <div className="card-header text-end text-small-1">
                                                    لیست باتری های ارسالی
                                                    &nbsp;

                                                </div>

                                                <div className="text-body-secondary text-big-2">
                                                    {
                                                        order?.battery_qty_detail?.length > 0 &&
                                                        <table className="table  text-small-2">
                                                            <thead className='text-center'>
                                                            <tr>
                                                                <th scope="col">#</th>
                                                                <th scope="col">برند</th>
                                                                <th scope="col">آمپراژ</th>
                                                                <th scope="col">نوع</th>
                                                                <th scope="col">تعداد</th>
                                                                <th scope="col">توضیحات</th>

                                                            </tr>
                                                            </thead>
                                                            <tbody className='text-center'>
                                                            {
                                                                order?.battery_qty_detail?.map((cart, index) => {
                                                                    return (
                                                                        <tr key={index}>
                                                                            <th scope="row">{index + 1}</th>
                                                                            <td>{cart.brand}</td>
                                                                            <td>{cart.amperage}</td>
                                                                            <td>{cart.batteryType}</td>
                                                                            <td>{cart.count}</td>
                                                                            <td>{cart.batteryDescription}</td>

                                                                        </tr>
                                                                    )
                                                                })
                                                            }
                                                            </tbody>
                                                        </table>
                                                    }

                                                </div>
                                            </div>
                                        </div>


                                    </div>


                                </div>
                            </div>

                        </div>


                    </div>
                </section>

            </main>

        </React.Fragment>
    );
}

export default OrderDetails;